import api from "./api";

export const PublicEventAPI = {
  list: () => api.get("/api/events"),

  getTicketStats: (id) =>
  api.get(`/api/events/${id}/ticket-stats`),

  get: (id) => api.get(`/api/events/${id}`),
};
